import React from 'react';
import Icon from '../../../components/AppIcon';

const UserProfilePanel = ({ data, loading }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date?.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getRoleBadgeColor = (role) => {
    if (role === 'admin') return 'bg-primary/10 text-primary border-primary/20';
    return 'bg-muted text-muted-foreground border-border';
  };

  const getSubscriptionBadge = (status) => {
    const badges = {
      active: { color: 'bg-success/10 text-success border-success/20', label: 'Active' },
      inactive: { color: 'bg-muted text-muted-foreground border-border', label: 'Inactive' },
      trial: { color: 'bg-warning/10 text-warning border-warning/20', label: 'Trial' },
      cancelled: { color: 'bg-error/10 text-error border-error/20', label: 'Cancelled' }
    };
    return badges?.[status] || badges?.inactive;
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-md">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-success/10">
            <Icon name="User" size={20} color="var(--color-success)" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">user_profiles Table</h3>
            <p className="text-xs text-muted-foreground">Profile and role data</p>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-6">
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        ) : data ? (
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Profile ID</label>
                <p className="text-sm font-mono text-foreground bg-muted p-2 rounded break-all">{data?.id}</p>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Email</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{data?.email}</p>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Full Name</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{data?.full_name || 'N/A'}</p>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Role</label>
                <div className="flex items-center gap-2">
                  <span className={`inline-flex items-center px-3 py-1.5 rounded-md text-sm font-medium border ${getRoleBadgeColor(data?.role)}`}>
                    {data?.role}
                  </span>
                </div>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Company Name</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{data?.company_name || 'N/A'}</p>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Job Title</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{data?.job_title || 'N/A'}</p>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Subscription Status</label>
                <div className="flex items-center gap-2">
                  {data?.subscription_status ? (
                    <span className={`inline-flex items-center px-3 py-1.5 rounded-md text-sm font-medium border ${getSubscriptionBadge(data?.subscription_status)?.color}`}>
                      {getSubscriptionBadge(data?.subscription_status)?.label}
                    </span>
                  ) : (
                    <span className="text-sm text-muted-foreground">N/A</span>
                  )}
                </div>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Created At</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{formatDate(data?.created_at)}</p>
              </div>
              <div className="space-y-1 md:col-span-2">
                <label className="text-xs font-medium text-muted-foreground">Updated At</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{formatDate(data?.updated_at)}</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-8 text-muted-foreground">
            <Icon name="AlertCircle" size={32} className="mx-auto mb-2 opacity-50" />
            <p>No profile data available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserProfilePanel;